import { useEffect } from 'react'

/**
 * Basic content protection: blocks the context menu, image dragging and the
 * usual devtools/view-source shortcuts.
 *
 * Note: this is a deterrent, not real security — anything shipped to the
 * browser can still be read by a determined user.
 */
export function useContentProtection() {
  useEffect(() => {
    const blockContextMenu = (event: MouseEvent) => {
      event.preventDefault()
    }

    const blockDrag = (event: DragEvent) => {
      const target = event.target as HTMLElement | null
      if (target?.tagName === 'IMG') {
        event.preventDefault()
      }
    }

    const blockShortcuts = (event: KeyboardEvent) => {
      const key = event.key.toLowerCase()
      const isDevtools =
        event.key === 'F12' ||
        ((event.ctrlKey || event.metaKey) &&
          event.shiftKey &&
          ['i', 'j', 'c'].includes(key)) ||
        ((event.ctrlKey || event.metaKey) && ['u', 's'].includes(key))

      if (isDevtools) {
        event.preventDefault()
        event.stopPropagation()
      }
    }

    document.addEventListener('contextmenu', blockContextMenu)
    document.addEventListener('dragstart', blockDrag)
    document.addEventListener('keydown', blockShortcuts, true)

    return () => {
      document.removeEventListener('contextmenu', blockContextMenu)
      document.removeEventListener('dragstart', blockDrag)
      document.removeEventListener('keydown', blockShortcuts, true)
    }
  }, [])
}
